import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import "./SellProgramSection.css";
import { formattedText } from "@/components/sell/utils/TextFormatter";

const SellProgramSection = ({ cmsData = [] }) => {
  // Early validation and default values
  if (!Array.isArray(cmsData)) {
    console.warn("HowItWorks: cmsData should be an array");
    cmsData = [];
  }
  // Safely access the data with fallbacks
  const hubzuCmsData =
    cmsData.length > 0 ? cmsData[0]?.benefitProgram || {} : {};

  const programDetails = hubzuCmsData?.details?.["@nodes"]
    ? hubzuCmsData?.details?.["@nodes"].reduce((acc, node) => {
        if (hubzuCmsData?.details?.[node]) {
          acc.push(hubzuCmsData.details[node]);
        }
        return acc;
      }, [])
    : [];

  return (
    <div
      className="sell-benefit-background"
      style={{
        backgroundImage: `url(${hubzuCmsData?.bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="sell-benefits-section">
        <div className="sell-benefits-section-title">
          <h2 style={{ lineHeight: "58px" }}>
            {formattedText(hubzuCmsData?.title)}
          </h2>
        </div>
        <Row>
          <Col md={6}>
            {programDetails.length > 0 &&
              programDetails.map((item, index) => {
                return (
                  <Card
                    className={`sell-benefit-card sell-benefit-card-${
                      index + 1
                    }`}
                  >
                    <h5>{item.title}</h5>
                    <p>{item.description}</p>
                  </Card>
                );
              })}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SellProgramSection;
